import React, { useReducer, useContext } from "react"
import { Action } from "../models/Action";
import policymanagementApi from "../api/policymanagement.api";
import { useParams } from "react-router-dom";
import { EventEmitterService, EventKey } from "../services/EventEmitterService";
import { awaitWithLoading } from "../services/utils";
import { PolicyManagementContextStore, ACTIONS as PolicyManagementContextActions } from './PolicyManagementContext';
import { ActiveInsuranceModel } from "../models/insurance-models/ActiveInsuranceModel";
import { SUBSCRIPTION_STATE } from "../models/insurance-models/PolicySubscriptionState";
import PolicyManagementRenewalApi from '../api/policmanagement.renewal.api';
import { PolicyRenewalContextStore } from "./PolicyRenewalContext";
import { InsuranceStatus } from '../models/insurance-models/InsuranceStatus';

export const ACTIONS = {
    SWITCH_CURRENT_RENEWAL_OFFERS: 'SWITCH_CURRENT_RENEWAL_OFFERS',
    LOAD_RENEWAL_OFFERS: 'LOAD_RENEWAL_OFFERS',
    NEW_EXTENSION_OFFER: 'NEW_EXTENSION_OFFER',
    LOAD_OFFERS: 'LOAD_OFFERS',
}

const defaultState = {
    dispatch: (action: Action) => {},
    purchaseLiabilityExtension: (selectedOffer) => {},
    offers: [],
    currentOffers: [],
}

const reducer = (state, action: Action) => {
    switch (action.type) {
        case ACTIONS.LOAD_OFFERS:
            return {...state, offers: action.data, currentOffers: action.data}
        case ACTIONS.SWITCH_CURRENT_RENEWAL_OFFERS:
            return {...state, offers: action.data.offers}
      default: 
        return state
    }
};


export const PolicyLiabilityExtensionContextStore = React.createContext(defaultState)

const PolicyLiabilityExtensionContext = (props) => {
    const [state, dispatch] = useReducer(reducer, defaultState)
    const policyManagementContext = useContext(PolicyManagementContextStore)
    const policyRenewalContext = useContext(PolicyRenewalContextStore)
const insuranceId = props.insurance.insuranceId
const insurance = props.insurance
    
    const loadLiabilityExtensionOffers = async () => {
        let offers = await policymanagementApi.getLiabilityExtensionOffers(insuranceId)
        offers = offers.parsedData.filter(offer=>offer.liabilityLimit != 10000000)
        dispatch(new Action(ACTIONS.LOAD_OFFERS, offers))
    }

    const purchaseLiabilityExtension = async (selectedOffer) => {
        let res = undefined
        let previousLiability = policyManagementContext.getInsurance(insuranceId).subscription.liabilityLimit;

        if(policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT)
            res = await awaitWithLoading(policymanagementApi.applyLiabilityExtension(insuranceId, selectedOffer.offerId ))
        if(policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.RENEWAL)
            res = await awaitWithLoading(PolicyManagementRenewalApi.applyLiabilityLimit(insuranceId, selectedOffer.liabilityLimit))
        if(res && res.ok) {
            policyManagementContext.dispatch(new Action(PolicyManagementContextActions.UPDATE_INSURANCE,
                { insurance: res.parsedData }))
            EventEmitterService.dispatch(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS)
            loadLiabilityExtensionOffers()
            let liabilityDirectionText = previousLiability > res.parsedData.subscription.liabilityLimit? "decreased" : "increased";
            if (policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT){
                EventEmitterService.dispatch(EventKey.ShowSuccess, {title: `Liability has been ${liabilityDirectionText}`, body: "Your changes have been made. An email will be sent to you with the policy’s updated liability endorsement."})
            }
            else if (policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.RENEWAL){
                EventEmitterService.dispatch(EventKey.ShowSuccess, {title: `Liability has been ${liabilityDirectionText} for your upcoming renewal`, body: "The changes will appear on your next policy."})
            }
        }
        else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    React.useEffect(() => {
        if(insurance.getStatus() === InsuranceStatus.ACTIVE){
            loadLiabilityExtensionOffers()
        }
    }, [])

    React.useEffect(() => {
        if((state.currentOffers && state.currentOffers.length > 0) || policyRenewalContext.renewalOffers.length > 0) {
            dispatch(new Action(ACTIONS.SWITCH_CURRENT_RENEWAL_OFFERS, {
                offers: policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ?
                     state.currentOffers : policyRenewalContext.renewalOffers
            }))
        }
    }, [policyRenewalContext.insuranceSubscriptionState, state.currentOffers, policyRenewalContext.renewalOffers])

    return (<PolicyLiabilityExtensionContextStore.Provider value={{ ...state, purchaseLiabilityExtension, dispatch }}>
            {props.children}
        </PolicyLiabilityExtensionContextStore.Provider>)   
}

export default PolicyLiabilityExtensionContext



